<template>
  <div v-if="options !== null && options !== undefined">
    <pbas-data-table
      v-if="provider"
      :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      fileNamePrefix="hours-history"
      :identifier="'hours_history_table' + selectedPlan.Id"
      :floatActions="floatActions"
      @error="error = $event"
      :show-select="false"
      :canExpand="(item) => item.TotalRecords"
      :showExpand="true"
      :generateProviderForExpanded="(item) => generateProvider(item)"
      :sortBy="'Term/EndDate'"
      :sortDescending="true"
    ></pbas-data-table>
    <v-container fluid grid-list-md v-else>
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="loading" scrollable max-width="100px" persistent>
      <v-container fluid grid-list-md>
        <v-layout row justify-center>
          <v-flex xs12 sm6 md4 lg3>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-dialog
      v-model="dialogs.showForm"
      scrollable
      max-width="1000px"
      persistent
    >
      <!-- :title="$t('components.memberview.add_hours_{0}', [getName()])" -->
      <member-hours-form
        v-if="dialogs.showForm"
        :employerId="employerId"
        :item="selectedItem"
        @close="dialogs.showForm = false"
        @save="
          dialogs.showForm = false;
          $refs.table.getDataAsync();
          $emit('refresh-eligible');
        "
        :memberGroupIdentityId="memberGroupIdentityId"
      />
    </v-dialog>
    <!-- <v-dialog v-model="showDelete" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ $t("components.hoursbulktable.delete_title") }}
        </v-card-title>
        <v-card-text>
          {{ $t("components.hoursbulktable.delete_warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="showDelete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" @click="deleteItem" :loading="saving">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <!-- <v-dialog v-model="showNote" max-width="700px" scrollable>
      <v-card v-if="selectedItem">
        <v-card-title>
          {{ selectedItem.Title }}
        </v-card-title>
        <v-divider />
        <v-card-text>
          <div style="padding:10px 0;" v-html="selectedItem.Text"></div>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <div v-if="!showActive" style="padding:10px 0;" v-html="'Comment: '+selectedItem.ArchiveReason"></div>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn text @click="showNote = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import MembersHoursHeaders from "@/headers/MembersHours";
import MemberHoursForm from "@/components/MemberView/Hours/MemberHoursForm";
import ErrorHandler from "@/components/ErrorHandler";
import { locker } from "@/mixins/locker";
import getHeaders from "@/headers/MembersHoursHistory";

export default {
  props: {
    memberId: String,
    employerId: String,
    showActive: {
      default: true,
    },
    memberGroupIdentityId:String
  },
  mixins: [locker],
  components: {
    MemberHoursForm,
    ErrorHandler,
  },
  data() {
    return {
      loading: false,
      valid: true,
      reason: null,
      // showNote: false,
      saving: false,
      // showDelete: false,
      provider: null,
      // rowActions: [
      //   // {
      //   //   title: "views.dashboard.view",
      //   //   name: "view",
      //   //   icon: "visibility",
      //   //   handler: (item) => {
      //   //     this.selectedItem = item;
      //   //     this.showNote = true;
      //   //   },
      //   // },
      //   {
      //     title: "globals.edit",
      //     name: "edit",
      //     icon: "edit",
      //     handler: async (item) => {
      //       try {
      //         this.loading = true;
      //         this.selectedItem = await this.lock(
      //           this.getMemberHours,
      //           {
      //             planIdentityId: this.selectedPlan.Id,
      //             memberIdentityId: this.memberId,
      //             id: item.Id,
      //             dialogs: this.dialogs,
      //             dialog: "showForm",
      //           },
      //           () => {
      //             this.dialogs.showForm = false;
      //           }
      //         );
      //         this.dialogs.showForm = true;
      //       } catch (error) {
      //         this.error = error;
      //       } finally {
      //         this.loading = false;
      //       }
      //     },
      //   },
      //   {
      //     title: "globals.delete",
      //     name: "delete",
      //     icon: "delete",
      //     handler: (item) => {
      //       this.selectedItem = item;
      //       this.showDelete = true;
      //     },
      //   },
      // ],
      floatActions: [
        {
          text: "globals.add_new",
          color: this.$vuetify.theme.themes.light.success,
          name: "add",
          icon: "add",
          handler: () => {
            this.selectedItem = {
              MemberId: this.memberId,
              PlanId: this.selectedPlan.Id,
              EmployerId: this.employerId,
              TermId: null,
              // StartDate: null,
              // EndDate: null,
              Amount: "",
              CreatedAt: null,
              ChangedAt: null,
            };
            this.dialogs.showForm = true;
          },
        },
      ],
      dialogs: {
        showForm: false,
      },
      selectedItem: null,
      error: null,
    };
  },
  methods: {
    ...mapActions("plansMembers", [
      //"deleteMemberHours", 
      "getMemberHours"]),
    async loadData() {
      this.provider = null;
      if (this.memberId && this.employerId) {
        const hoursHistoryUrl = `/plans/${this.selectedPlan.Id}/members/${this.memberId}/hour-reports`;
        this.provider = new ODataProvider(
          this.$axiosHttp,
          hoursHistoryUrl,
          MembersHoursHeaders
        );
      }
    },

    // async deleteItem() {
    //   this.saving = true;
    //   this.error = null;
    //   try {
    //     await this.deleteMemberHours({
    //       planIdentityId: this.selectedPlan.Id,
    //       memberIdentityId: this.memberId,
    //       id: this.selectedItem.Id,
    //     });
    //     this.$refs.table.getDataAsync();
    //     this.$emit("refresh-eligible");
    //   } catch (e) {
    //     console.error(e);
    //     this.error = e;
    //   } finally {
    //     this.saving = false;
    //     this.showDelete = false;
    //   }
    // },

    generateProvider(item) {
      const url =
        "plans/" +
        this.selectedPlan.Id +
        "/members/" +
        this.memberId +
        "/term/" +
        item.Term.Id +
        "/hour-reports";
      return new ODataProvider(
        this.$axiosHttp,
        url,
        getHeaders(this.options.Enums.Reason)
      );
      // return undefined;
    },
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["role"]),
  },
  watch: {
    memberId: {
      immediate: true,
      handler: async function () {
        await this.loadData();
      },
    },
    employerId: {
      immediate: true,
      handler: async function () {
        await this.loadData();
      },
    },
  },
  // mounted() {
  //   console.log("id", this.memberId);
  //   console.log("employer", this.employerId);
  // },
};
</script>
